


































































































































































































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {
  TenantPoolEvent,
  TenantPoolRow,
  eventLevelMeta,
  formatDateTime,
  relativeTime,
  statusMeta
} from "@/entity/TenantPoolEntity";

/** Detayda gösterilecek alanlar ve Türkçe etiketleri (görüntüleme sırası). */
const ALANLAR: { anahtar: keyof TenantPoolRow; etiket: string; tarihMi?: boolean }[] = [
  {anahtar: "id", etiket: "Havuz satırı no"},
  {anahtar: "tenant_id", etiket: "Tenant ID"},
  {anahtar: "db_name", etiket: "Veritabanı"},
  {anahtar: "stage", etiket: "Aşama"},
  {anahtar: "assign_attempts", etiket: "Atama denemesi"},
  {anahtar: "reserved_by", etiket: "Rezerve eden"},
  {anahtar: "assigned_to", etiket: "Atanan"},
  {anahtar: "license_id", etiket: "Lisans no"},
  {anahtar: "migration_fingerprint", etiket: "Migration parmak izi"},
  {anahtar: "created_at", etiket: "Oluşturulma", tarihMi: true},
  {anahtar: "provisioning_started_at", etiket: "Üretim başlangıcı", tarihMi: true},
  {anahtar: "provisioned_at", etiket: "Üretim bitişi", tarihMi: true},
  {anahtar: "heartbeat_at", etiket: "Son nabız", tarihMi: true},
  {anahtar: "reserved_at", etiket: "Rezerve zamanı", tarihMi: true},
  {anahtar: "reserved_until", etiket: "Rezerve bitişi", tarihMi: true},
  {anahtar: "assigned_at", etiket: "Atanma zamanı", tarihMi: true},
  {anahtar: "failed_at", etiket: "Hata zamanı", tarihMi: true},
  {anahtar: "updated_at", etiket: "Güncellenme", tarihMi: true},
  {anahtar: "deleted_at", etiket: "İmha zamanı", tarihMi: true},
];

/**
 * İmha rotasındaki statüler. Diğerleri (available, reserved, provisioning)
 * uçtan `not_candidate` alır — beklemekle uygun hâle GELMEZLER, ama `force`
 * ile aşılabilirler. Bu yüzden liste artık düğmeyi gizlemek için değil,
 * operatörü uyarmak için kullanılıyor.
 */
const IMHA_ROTASI: string[] = ["error", "orphaned", "destroying"];

/**
 * Olay `context`'inde sunucunun geçirdiği beyaz listeli anahtarların Türkçe
 * etiketleri. Ham JSON dökmek yerine bunlar etiketli gösterilir.
 */
/**
 * Zaman çizelgesinde tek seferde basılacak azami olay. `GET /tenants/{id}`
 * olayları sayfalamadan döndürür; çok tekrar denenmiş bir satırda liste
 * binlerce kayda çıkabilir ve çekmece kilitlenir.
 */
const TIMELINE_LIMIT = 200;

const BAGLAM_ETIKETLERI: { [key: string]: string } = {
  error_code: "Hata kodu",
  exception_class: "İstisna",
  fingerprint: "Parmak izi",
  reason: "Sebep",
  stage: "Aşama",
  note: "Not"
};

@Component
export default class TenantPoolDetay extends Vue {
  /** Çekmece açık mı (v-model). */
  @Prop({type: Boolean, default: false}) readonly value!: boolean;
  /** Gösterilecek havuz satırının id'si. */
  @Prop({type: Number, default: null}) readonly poolId!: number | null;
  /** Okuma uçlarının taban yolu (sonunda / ile). */
  @Prop({type: String, required: true}) readonly okumaBase!: string;
  /**
   * Mutasyon uçlarının taban yolu (`admin/tenant-pool/panel/`). Boş string ise
   * yazma yapılamaz ve imha düğmesi hiç gösterilmez.
   */
  @Prop({type: String, default: ""}) readonly mutasyonBase!: string;
  /** Sunucu mutasyonlara açık mı (summary.mutations_enabled). */
  @Prop({type: Boolean, default: false}) readonly mutasyonlarAcik!: boolean;

  pool: TenantPoolRow | null = null;
  olaylar: TenantPoolEvent[] = [];
  yukleniyor: boolean = false;
  yuklemeHatasi: string = "";

  onayDialog: boolean = false;
  zorlaDialog: boolean = false;
  imhaEdiliyor: boolean = false;
  riskKabul: boolean = false;
  zorlaMesaji: string = "";
  uygunlukZamani: string = "";
  /** Zorlama diyaloğunun sebebi: 'grace_period' | 'not_candidate'. */
  zorlaSebebi: string = "";
  /** `not_candidate` yanıtındaki `data.status`. */
  adayDisiDurum: string = "";
  tumOlaylariGoster: boolean = false;
  /** İmha başarısızlığı sonucu: 'race' | 'refused' | 'purge_failed'. */
  sonucDialog: boolean = false;
  sonucSebebi: string = "";
  sonucMesaji: string = "";
  /** Uçuştaki detay isteğini bayatlatmak için artan sıra numarası. */
  private istekSirasi: number = 0;

  get durumBilgisi() {
    return statusMeta(this.pool ? this.pool.status : null);
  }

  /** Kronolojik listenin SONU en yenidir; sınır aşılırsa en yeniler gösterilir. */
  get gorunurOlaylar(): TenantPoolEvent[] {
    if (this.tumOlaylariGoster || this.olaylar.length <= TIMELINE_LIMIT) {
      return this.olaylar;
    }
    return this.olaylar.slice(this.olaylar.length - TIMELINE_LIMIT);
  }

  get gizlenenOlaySayisi(): number {
    if (this.tumOlaylariGoster) {
      return 0;
    }
    return Math.max(0, this.olaylar.length - TIMELINE_LIMIT);
  }

  get sonucBaslik(): string {
    if (this.sonucSebebi === "race") {
      return "Satır Devralındı";
    }
    if (this.sonucSebebi === "purge_failed") {
      return "İmha Başarısız — Veritabanı Duruyor Olabilir";
    }
    if (this.sonucSebebi === "grace_period") {
      return "Gözlem Penceresi Dolmadı";
    }
    if (this.sonucSebebi === "not_candidate") {
      return "Satır İmha Adayı Değil";
    }
    return "İmha Reddedildi";
  }

  /** `purge_failed` gerçek bir arıza: uyarı seviyesinde gösterilmeli. */
  get sonucRengi(): string {
    return this.sonucSebebi === "purge_failed" ? "error" : "warning";
  }

  /**
   * Yalnızca `refused` ve `purge_failed` olay zincirine kayıt yazar.
   * `race`, `grace_period` ve `not_candidate` yazmaz — kullanıcıyı oraya
   * yönlendirmek onu var olmayan bir kaydı aramaya gönderir.
   */
  get sonucOlayZincirindeVar(): boolean {
    return this.sonucSebebi === "refused" || this.sonucSebebi === "purge_failed";
  }

  /**
   * İmha edilmiş satır dışında düğme her zaman görünür: hangi sebeple
   * reddedileceğine (ve `force` ile aşılıp aşılamayacağına) sunucu karar verir.
   */
  get imhaEdilebilir(): boolean {
    return this.yazmaAcik && this.pool !== null && !this.pool.deleted_at;
  }

  get yazmaAcik(): boolean {
    return this.mutasyonlarAcik && this.mutasyonBase !== "";
  }

  /** İmha rotasında olmayan statüler uçtan `not_candidate` alır — önceden uyar. */
  get imhaAdayiMi(): boolean {
    return this.pool !== null && IMHA_ROTASI.indexOf(this.pool.status) !== -1;
  }

  get zorlaBaslik(): string {
    return this.zorlaSebebi === "not_candidate"
        ? "İmha Adayı Değil — Zorla İmha"
        : "Gözlem Penceresi — Zorla İmha";
  }

  /** Onay metni sebebe göre değişir: ne kabul edildiği açık olmalı. */
  get zorlaOnayMetni(): string {
    if (this.zorlaSebebi === "not_candidate") {
      return "Bu satırın imha adayı olmadığını biliyorum; " + this.adayDisiDurumEtiketi
          + " durumundaki tenant'ın kalıcı olarak yok edilmesini kabul ediyorum.";
    }
    return "Yanlış-pozitif riskini kabul ediyorum; satır gözlem penceresi dolmadan imha edilsin.";
  }

  /** `data.status` ham değeri yerine ekran sözlüğündeki Türkçe karşılığı. */
  get adayDisiDurumEtiketi(): string {
    return this.adayDisiDurumMeta.text;
  }

  get adayDisiDurumRengi(): string {
    return this.adayDisiDurumMeta.color;
  }

  /**
   * Sunucunun bildirdiği durum, ekrandakinden farklı olabilir (arada değişmiş
   * olabilir); onay metni sunucunun söylediğini göstermeli.
   */
  private get adayDisiDurumMeta() {
    if (this.adayDisiDurum) {
      return statusMeta(this.adayDisiDurum);
    }
    return statusMeta(this.pool ? this.pool.status : null);
  }

  get gorunurAlanlar(): { anahtar: string; etiket: string; deger: string }[] {
    const p = this.pool;
    if (!p) {
      return [];
    }
    const satirlar: { anahtar: string; etiket: string; deger: string }[] = [];
    ALANLAR.forEach(alan => {
      const ham = (p as any)[alan.anahtar];
      if (ham === null || ham === undefined || ham === "") {
        return; // boş alanı hiç gösterme — ekran gürültüsü olmasın
      }
      satirlar.push({
        anahtar: alan.anahtar as string,
        etiket: alan.etiket,
        deger: alan.tarihMi ? formatDateTime(ham) : String(ham)
      });
    });
    return satirlar;
  }

  @Watch("poolId")
  onPoolIdDegisti(yeni: number | null) {
    // Başka bir satıra geçiliyor: eski satırın verisi ve YARIM KALMIŞ ONAYLARI
    // taşınmamalı — aksi halde açık kalan bir imha diyaloğu yanlış tenant'ı
    // hedef alabilir.
    this.durumuSifirla();
    if (yeni !== null && this.value) {
      this.getir();
    }
  }

  @Watch("value")
  onAcildi(acik: boolean) {
    if (acik) {
      if (this.poolId !== null) {
        this.getir();
      }
      return;
    }
    // Çekmece kapandı (dış tıklama dahil): v-dialog'lar body'ye taşındığı için
    // kendiliğinden kapanmazlar. Elle kapat.
    this.dialoglariKapat();
  }

  /** Açık onayları kapatır; devam eden bir imha varsa ona dokunmaz. */
  private dialoglariKapat() {
    this.onayDialog = false;
    this.zorlaDialog = false;
    this.sonucDialog = false;
    this.riskKabul = false;
  }

  private durumuSifirla() {
    this.istekSirasi++; // uçuştaki yanıt varsa artık bayat
    this.dialoglariKapat();
    this.tumOlaylariGoster = false;
    this.pool = null;
    this.olaylar = [];
    this.yuklemeHatasi = "";
    this.zorlaMesaji = "";
    this.uygunlukZamani = "";
    this.sonucSebebi = "";
    this.sonucMesaji = "";
  }

  tarih(deger: string | null): string {
    return formatDateTime(deger);
  }

  gecenSure(deger: string | null): string {
    return relativeTime(deger);
  }

  olayRengi(seviye: string): string {
    return eventLevelMeta(seviye).color;
  }

  olayIkonu(seviye: string): string {
    return eventLevelMeta(seviye).icon;
  }

  /**
   * Beyaz listeli `context` alanlarını etiketli chip'lere çevirir; ham JSON
   * dökmez. Bilinmeyen bir anahtar gelirse adı olduğu gibi kullanılır.
   */
  baglamListesi(olay: TenantPoolEvent): { anahtar: string; etiket: string; deger: string }[] {
    const baglam = olay.context;
    if (!baglam || typeof baglam !== "object") {
      return [];
    }
    return Object.keys(baglam)
        .filter(k => baglam[k] !== null && baglam[k] !== "")
        .map(k => ({
          anahtar: k,
          etiket: BAGLAM_ETIKETLERI[k] || k,
          deger: String(baglam[k])
        }));
  }

  kapat() {
    this.$emit("input", false);
  }

  /**
   * Yanıt geldiğinde hâlâ AYNI satır isteniyor mu diye bakılır. Aksi halde
   * geç dönen bir yanıt, kullanıcının o an baktığı satırın verisini ezebilir —
   * ve imha onayındaki `db_name` yanlış tenant'ı gösterir. Geri alınamaz bir
   * işlemin tek insan doğrulaması burası olduğu için bu kontrol zorunlu.
   */
  async getir() {
    if (this.poolId === null) {
      return;
    }
    const sira = ++this.istekSirasi;
    const istenenId = this.poolId;
    this.yukleniyor = true;
    this.yuklemeHatasi = "";
    try {
      const yanit = await this.$http.get(this.okumaBase + "tenants/" + istenenId);
      if (sira !== this.istekSirasi) {
        return; // daha yeni bir istek var — bu yanıt bayat
      }
      const veri = yanit.data && yanit.data.data ? yanit.data.data : {};
      this.pool = veri.pool || null;
      this.olaylar = Array.isArray(veri.events) ? veri.events : [];
    } catch (e) {
      if (sira !== this.istekSirasi) {
        return;
      }
      this.pool = null;
      this.olaylar = [];
      this.yuklemeHatasi = this.hataMesaji(e);
    } finally {
      if (sira === this.istekSirasi) {
        this.yukleniyor = false;
      }
    }
  }

  zorlaDialogKapat() {
    this.zorlaDialog = false;
    this.riskKabul = false;
    this.zorlaSebebi = "";
    this.adayDisiDurum = "";
  }

  async imhaEt(zorla: boolean) {
    if (this.poolId === null || this.mutasyonBase === "") {
      return;
    }
    // Vuetify'da `loading` tıklamayı ENGELLEMEZ (VBtn yalnızca `disabled`e bakar).
    // Çift tıklama iki purge isteği gönderirse ikincisi janitor kilidine
    // düşer ve operatöre hiç yazılmamış bir purge_refused olayına atıfta
    // bulunan yanıltıcı bir red diyaloğu gösterilir.
    if (this.imhaEdiliyor) {
      return;
    }
    this.imhaEdiliyor = true;
    try {
      // Boş obje FormData'ya çevrilmez; axios onu "[object Object]" gövdesine
      // dönüştürür. Gövdesiz POST için undefined geçilmeli.
      const govde: any = zorla ? {force: true} : undefined;
      await this.$http.post(this.mutasyonBase + "tenants/" + this.poolId + "/purge", govde);

      this.onayDialog = false;
      this.zorlaDialogKapat();
      this.$toast.success("Tenant imha edildi.");
      this.$emit("purged", this.poolId);
      this.kapat();
    } catch (e) {
      this.imhaHatasi(e, zorla);
    } finally {
      this.imhaEdiliyor = false;
    }
  }

  /**
   * İmha başarısızlığının BEŞ ayrı anlamı var ve operatöre aynı görünmemeleri
   * kritik. `force` YALNIZCA ilk ikisinde anlamlıdır:
   *
   *  1. 409 `grace_period`  → gözlem penceresi/retention dolmadı.
   *     `data.eligible_at` ne zaman dolacağını söyler. force AŞAR.
   *  2. 409 `not_candidate` → satır imha adayı değil (`data.status`).
   *     Beklemekle uygun hâle GELMEZ, eligible_at yok. force AŞAR — ama bu
   *     sağlıklı bir havuz satırını yok etmek demek: daha güçlü onay.
   *  3. 409 `refused`       → guard reddetti. force AŞAMAZ; "zorla" seçeneği
   *     hiç sunulmaz. `purge_refused` olayı var.
   *  4. 409 `race`          → satırı başka bir işlem devraldı. OLAY ZİNCİRİNE
   *     HİÇBİR ŞEY YAZILMAZ; doğru davranış listeyi tazelemek.
   *  5. 500 `purge_failed`  → satır error/PURGE_FAILED ve VERİTABANI HÂLÂ
   *     DURUYOR OLABİLİR. Sessizce yutulmamalı.
   *
   * Her durumda gösterilen metin sunucunun `message` alanıdır.
   */
  private imhaHatasi(e: any, zorlaDenendi: boolean) {
    const yanit = e && e.response;
    if (!yanit) {
      this.$toast.error(this.hataMesaji(e));
      return;
    }

    const govde = yanit.data || {};
    const veri = govde.data || {};
    const sunucuMesaji = govde.message || "";
    const sebep = veri.reason ? String(veri.reason) : "";

    // 1-2. force ile aşılabilen iki sebep. `force` ile tekrar denendiyse
    //      buraya düşmez: sunucu artık gerçek sebebi (refused/race/...) döner.
    if (!zorlaDenendi && (sebep === "grace_period" || sebep === "not_candidate")) {
      this.onayDialog = false;
      this.zorlaSebebi = sebep;
      this.zorlaMesaji = sunucuMesaji;
      this.uygunlukZamani = veri.eligible_at ? String(veri.eligible_at) : "";
      this.adayDisiDurum = veri.status ? String(veri.status) : "";
      this.riskKabul = false;
      this.zorlaDialog = true;
      return;
    }

    // `reason` göndermeyen eski sürüm uyumluluğu: 409 + eligible_at.
    if (!zorlaDenendi && sebep === "" && yanit.status === 409
        && veri.eligible_at !== null && veri.eligible_at !== undefined) {
      this.onayDialog = false;
      this.zorlaSebebi = "grace_period";
      this.zorlaMesaji = sunucuMesaji || "Satır henüz gözlem penceresinde.";
      this.uygunlukZamani = String(veri.eligible_at);
      this.adayDisiDurum = "";
      this.riskKabul = false;
      this.zorlaDialog = true;
      return;
    }

    this.onayDialog = false;
    this.zorlaDialogKapat();

    // `reason` taşımayan hatalar bu sınıflandırmanın dışındadır: beklenmedik
    // 500 (reference'lı), 403, 503, ağ hatası... Bunları "İmha Reddedildi"
    // diye göstermek yanlış olur. 409 + reason yok ise guard reddi kabul
    // edilir (ucun `reason` eklenmeden önceki davranışı).
    if (sebep === "" && yanit.status !== 409) {
      this.$toast.error(this.hataMesaji(e));
      return;
    }

    // force denendikten sonra hâlâ aynı sebep geliyorsa (beklenmez) doğru
    // metni göster; bunlar olay zincirine kayıt yazmaz.
    if (sebep === "grace_period" || sebep === "not_candidate") {
      this.sonucSebebi = sebep;
      this.sonucMesaji = sunucuMesaji || "İmha yapılamadı.";
      this.sonucDialog = true;
      this.getir();
      return;
    }

    // 2. Yarış kaybı: burada bakılacak olay YOK, listenin tazelenmesi gerekiyor.
    if (sebep === "race") {
      this.sonucSebebi = "race";
      this.sonucMesaji = sunucuMesaji || "Bu satırı başka bir işlem devraldı.";
      this.sonucDialog = true;
      this.getir();                 // satırın güncel durumunu göster
      this.$emit("tazele");         // ana ekranda liste + özet yenilensin
      return;
    }

    // 4. İmha patladı: veritabanı duruyor olabilir — uyarı seviyesi.
    if (sebep === "purge_failed") {
      this.sonucSebebi = "purge_failed";
      this.sonucMesaji = sunucuMesaji || "İmha başarısız oldu.";
      this.sonucDialog = true;
      this.getir();                 // purge_failed olayı zincirde görünsün
      this.$emit("tazele");         // satır artık error/PURGE_FAILED
      return;
    }

    // 3. Guard reddi (ve `reason` göndermeyen eski sürümler): zorlamanın
    //    faydası yok, operatörü tekrar denemeye itme.
    this.sonucSebebi = "refused";
    this.sonucMesaji = sunucuMesaji || "İmha reddedildi.";
    this.sonucDialog = true;
    this.getir();                   // purge_refused olayı zincirde görünsün
  }

  /** Olay geçmişi bölümüne kaydırır — "zincire git" eylemi. */
  olayZincirineGit() {
    this.sonucDialog = false;
    this.$nextTick(() => {
      const hedef: any = this.$refs.olayGecmisi;
      if (hedef && hedef.scrollIntoView) {
        hedef.scrollIntoView({behavior: "smooth", block: "start"});
      }
    });
  }

  /** Sunucunun kendi mesajını olduğu gibi gösterir; metin uydurmaz. */
  private hataMesaji(e: any): string {
    const yanit = e && e.response;
    if (!yanit) {
      return "Sunucuya ulaşılamadı.";
    }
    const govde = yanit.data || {};
    if (yanit.status === 500 && govde.reference) {
      return (govde.message || "İşlem başarısız.") + " (Destek için referans: " + govde.reference + ")";
    }
    if (yanit.status === 503) {
      return govde.message || "Havuz operasyon uçları kapalı (token yapılandırılmamış).";
    }
    if (yanit.status === 403) {
      return govde.message || "Havuz operasyon yetkiniz yok.";
    }
    if (yanit.status === 429) {
      return "Hız sınırına ulaşıldı, biraz bekleyip tekrar deneyin.";
    }
    return govde.message || ("İstek başarısız (HTTP " + yanit.status + ").");
  }
}
